import { Component, OnInit,ViewChild } from '@angular/core'; 
import { switchMap } from 'rxjs/operators';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { loginService } from '../../service/login.service';
//import { } from '@types/googlemaps';
@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css'],
  providers:[loginService],
})
export class VerificationComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  emailVerification:any;
  msg="";
  msgclass="success";
  constructor(private route: ActivatedRoute,private _login:loginService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
        if(params['id']){
         this.emailVerification =params['id'];
         //console.log(this.emailVerification);
         this._login.verifystatuschange(this.emailVerification).subscribe((data : any)=>{
             //console.log(data);
             if(data.error==0){ 
                this.msg = data.message;
                this.msgclass="success";

             }
             else{
                this.msg = data.message;
                this.msgclass="danger";
                
             }

         })
        }
        
       // this.getForumDetail();
      });
    
  }





}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/verification/verification.component.ts